export interface UndoRedoState<T> {
  past: T[]
  present: T
  future: T[]
}

export const createUndoRedoState = <T>(present: T): UndoRedoState<T> => {
  return {
    past: [],
    present,
    future: [],
  }
}
